import { render, staticRenderFns } from "./VoiceAgentKnowledgeBaseDeleted.vue?vue&type=template&id=eb9ce8f6"
import script from "./VoiceAgentKnowledgeBaseDeleted.vue?vue&type=script&lang=js"
export * from "./VoiceAgentKnowledgeBaseDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports